var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIssueSeverity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.199,
    height: 20.23,
    viewBox: "0 0 20.199 20.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11518",
    "data-name": "Group 11518",
    transform: "translate(-1724.301 -5473.316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11516",
    "data-name": "Group 11516",
    transform: "matrix(-0.921, 0.391, -0.391, -0.921, 1744.5, 5489.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "np_open_3560720_000000",
    d: "M27.429,19.9A5.43,5.43,0,0,0,19,24.424h1.051a4.379,4.379,0,1,1,7.781,2.761,4.008,4.008,0,0,1-3.341,1.635c-1.973.18-1.313,1.109.22,1.031A5.43,5.43,0,0,0,27.429,19.9Z",
    transform: "translate(-19 -18.993)",
    fill: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "np_open_3560720_000000-2",
    "data-name": "np_open_3560720_000000",
    d: "M8.429.9A5.43,5.43,0,0,0,0,5.431l1.075.315A4.3,4.3,0,0,1,2.132,2.55,4.38,4.38,0,1,1,5.921,9.787c-1.142.129-1.743,1.148-.21,1.071A5.43,5.43,0,0,0,8.429.9Z",
    transform: "translate(0.003 10.867) rotate(-90)",
    fill: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "np_warning_3039045_000000",
    d: "M5.935,8.116,3.591,3.922a.646.646,0,0,0-1.154.008L.093,8.112A.7.7,0,0,0,.67,9.161H5.358a.693.693,0,0,0,.577-1.045Z",
    transform: "matrix(-0.921, -0.391, 0.391, -0.921, 5.457, 12.995)",
    fill: "#4a4a4a",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_9",
    "data-name": "Subtraction 9",
    d: "M7.763,15.587a7.793,7.793,0,1,1,7.763-7.793,7.891,7.891,0,0,1-.076,1.09,5.007,5.007,0,0,0-6.617,2.829,1.143,1.143,0,0,0-1.07-.638,1.255,1.255,0,1,0,.745,2.264c0,.047,0,.1,0,.16a4.972,4.972,0,0,0,.416,2A7.788,7.788,0,0,1,7.763,15.587ZM7.763,2A1.2,1.2,0,0,0,6.568,3.268l.353,6.207a.842.842,0,0,0,1.682,0l.354-6.207A1.2,1.2,0,0,0,7.763,2Z",
    transform: "translate(1724.301 5473.316)",
    fill: "#4a4a4a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIssueSeverity);
export default __webpack_public_path__ + "static/media/Icon_Issue_Severity.7ae2770a.svg";
export { ForwardRef as ReactComponent };